<template src="@/templates/serviceDelivery/sdPending.html"></template>

<script>
import ServiceDeliveryFormCollection from "@/collections/serviceDeliveryFormCollection";
import ServiceDeliveryFormModel from "@/models/serviceDeliveryFormModel";
import SDPendingDetails from "@/components/serviceDelivery/SDPendingDetails";
import BookingListItem from "@/components/bookings/BookingListItem";
import { mapState, mapActions } from "vuex";

export default {
  name: "SDPending",
  props: ["type", "booking_view"],
  components: {
    SDPendingDetails,
    BookingListItem,
  },
  watch: {
    $route: "fetchServiceDeliveryForm",
  },
  data() {
    return {
      serviceDeliveryFormCollection: new ServiceDeliveryFormCollection(),
      serviceDeliveryFormModel: new ServiceDeliveryFormModel(),
      viewSDPendingDetailsComp: false,
      sdType: "",
      bookingView: "",
    };
  },
  created() {
    this.fetchServiceDeliveryForm();
  },
  mounted() {
    Event.$on("hideSDPendingDetailsComp", () => {
      let thisComponent = this;
      setTimeout(function () {
        thisComponent.fetchServiceDeliveryForm();
      }, 50);
    });
  },
  computed: {
    ...mapState(["sideNav"]),
  },
  methods: {
    ...mapActions(["updateHideAll", "updateBackButton"]),
    fetchServiceDeliveryForm() {
      this.sdType = this.type;
      this.bookingView = this.booking_view;

      this.updateHideAll();
      this.updateBackButton(false);

      this.serviceDeliveryFormCollection
        .getSDFList(this.sdType)
        .then((SDFCollectionRes) => {
          this.serviceDeliveryFormCollection.models =
            SDFCollectionRes.response.data;
        })
        .catch((PCError) => {
          console.error("error status code SDPending");
          console.log(PCError.response.response.status);
          if (PCError.response) {
            if (PCError.response.response.status == "401") {
              Event.$emit("tokenExpiredLogout");
              return;
            }
          }

          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });
    },
    fetchError(errorMessage) {
      this.$vs.notify({
        title: "Error!",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    moreDeliveryDetails(model) {
      return (
        "Ref: " +
        model.ref_num +
        "\n" +
        "Language: " +
        model.language +
        "\n" +
        "Service Date: " +
        model.service_date_formatted +
        "\n" +
        "Duration: " +
        model.start +
        " to " +
        model.end
      );
    },
    viewSDForm(model) {
      this.serviceDeliveryFormModel.ref_num = model.ref_num;

      this.serviceDeliveryFormModel
        .viewSDDetails()
        .then((JARModelRes) => {
          let res = JARModelRes.response.data;
          let error = res.error;

          if (!error) {
            this.serviceDeliveryFormModel.dbData = res;
            this.viewSDPendingDetailsComp = true;
          } else {
            let errorMessage = "Fetch error. " + error;
            this.fetchError(errorMessage);
          }
        })
        .catch((SDPError) => {
          let errorMessage = "Network error. " + SDPError;
          this.fetchError(errorMessage);
          console.error(SDPError);
        });
    },
  },
};
</script>
